export enum InternalUserRole {
  ENG = 'ENG',
  SALES = 'SALES',
  EXTERNAL = 'EXTERNAL',
  WORKER_OPS_GLOBAL = 'WORKER_OPS_GLOBAL',
  WORKER_OPS_NYC = 'WORKER_OPS_NYC',
  CUSTOMER_OPS = 'CUSTOMER_OPS',
  TIMEKEEPING_OPS = 'TIMEKEEPING_OPS',
  CUSTOMER_OPS_MARKETPLACE = 'CUSTOMER_OPS_MARKETPLACE',
  CUSTOMER_OPS_SCALED_SYSTEMS = 'CUSTOMER_OPS_SCALED_SYSTEMS',
  CUSTOMER_OPS_ENTERPRISE = 'CUSTOMER_OPS_ENTERPRISE',
  SCALED_OPS = 'SCALED_OPS',
  SWAT = 'SWAT',
  OTHER = 'OTHER',
}

export const CUSTOMER_OPS_ROLES: readonly InternalUserRole[] = [
  InternalUserRole.CUSTOMER_OPS,
  InternalUserRole.CUSTOMER_OPS_MARKETPLACE,
  InternalUserRole.CUSTOMER_OPS_SCALED_SYSTEMS,
  InternalUserRole.CUSTOMER_OPS_ENTERPRISE,
]

export function isCustomerOpsRole(role: InternalUserRole): boolean {
  return (CUSTOMER_OPS_ROLES as readonly string[]).includes(role)
}

export const WORKER_OPS_ROLES: readonly InternalUserRole[] = [
  InternalUserRole.WORKER_OPS_NYC,
  InternalUserRole.CUSTOMER_OPS_SCALED_SYSTEMS,
]

export function isWorkerOpsRole(role: InternalUserRole): boolean {
  return (WORKER_OPS_ROLES as readonly string[]).includes(role)
}

import type { OpsConsolePreferences } from './ops-console-preferences'

export type {
  OpsConsoleAvaPreferences,
  OpsConsoleNeutronChatDrawerPreferences,
  OpsConsoleNeutronChatPreferences,
  OpsConsolePreferences,
  OpsConsolePreferencesPatch,
} from './ops-console-preferences'
export {
  DEFAULT_OPS_CONSOLE_PREFERENCES,
  MAX_CHAT_DRAWER_WIDTH,
  MIN_CHAT_DRAWER_WIDTH,
  mergeOpsConsolePreferencesPatch,
  OpsConsolePreferencesPatchSchema,
  OpsConsolePreferencesSchema,
} from './ops-console-preferences'

export type InternalUser = {
  id: string
  createdAt: Date
  updatedAt: Date
  email: string
  firstName: string
  lastName: string
  status: InternalUserStatus
  slackId: string
  rank: InternalUserRank
  phoneNumber?: string
  openPhoneUserId?: string
  internalUserRole: InternalUserRole
  opsConsolePreferences: OpsConsolePreferences
}

export enum InternalUserStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum InternalUserRank {
  ADMIN = 'ADMIN',
  OPS_ADMIN = 'OPS_ADMIN',
  OPS_LEAD = 'OPS_LEAD',
  SUPERVISOR = 'SUPERVISOR',
  USER = 'USER',
}
